import { useRouter } from "next/router";
import React, { useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import {
    categoryGet_req,
    filterProducts_req,
    getDiscountProduct_req,
    getFilterSize_req,
} from "../../api/api";
import Page from '../../components/Page'
import Banner from "../../components/banner";
import ProductItem from "../../components/productItem";
import SelectCustom from "../../components/select";
import NotFoundIcon from "../../assets/images/browser.png";
import LeftArrow from "../../assets/images/icons/left-chevron.png";
import RightArrow from "../../assets/images/icons/right-chevron.png";

const Discount = (query) => {
    const intl = useIntl();
    const router = useRouter();
    const locale = useSelector((state) => state.global.locale);

    const [productList, setProductList] = useState([]);
    const [changeCategory, setChangeCategory] = useState("");
    const [productsPage, setProductsPage] = useState(null);
    const [allCategory, setAllCategory] = useState([]);

    const [sizeData, setSizeData] = useState([]);
    const [changeSize, setChangeSize] = useState(
        query?.changeSize ? query.changeSize : ""
    );
    const [priceState, setPriceState] = useState({
        minPrice: "",
        maxPrice: "",
    });

    const [page, setPage] = useState(1);
    const queryData = query?.title;
    const currentPageQuery = router?.query?.id;
    const currentPageItem = Number(router?.query?.item);
    const currentChangeSize = router.query?.changeSize;

    const filteredData = async (data, sizeId, priceState, page, discount) => {
        const dataQuery = Number(data);

        const filterReq = await filterProducts_req(
            data && dataQuery > 0
                ? [dataQuery]
                : currentPageItem > 0
                    ? [currentPageItem]
                    : [],
            sizeId ? sizeId : undefined,
            priceState,
            page,
            discount
        );
        setProductsPage(filterReq.data);
        setProductList(filterReq.data.filteredProducts);
    };
    const onchangeRadio = async (evt) => {
        const value = Number(evt.target.value);

        setChangeCategory((evt.target.name = value));
        setChangeSize("");
        router.push(`/discount/1?item=${value}`);
        getFilterSizeData([value]);
        filteredData([value], null, priceState, page, 1);
    };
    const onchangeRadioSize = async (evt) => {
        const sizeValue = Number(evt.target.value);
        setChangeSize((evt.target.name = sizeValue));
        router.push(`/discount/1?item=${query.item}&changeSize=${sizeValue}`);
        filteredData([changeCategory], sizeValue, priceState, page, 1);
    };
    const getFilterSizeData = async (value) => {
        const dataValue = Number(value);
        const filterReq = await getFilterSize_req([dataValue]);
        setSizeData(filterReq.data);
    };

    const discountedProductReq = async (index) => {
        const responseData = await getDiscountProduct_req(index);

        if (responseData) {
            setProductsPage(responseData.data);
            setProductList(responseData.data.products);
        }
    };
    useEffect(() => {
        const minPriceData = sessionStorage.getItem("min");
        const maxPriceData = sessionStorage.getItem("max");
        setPriceState({
            minPrice: minPriceData,
            maxPrice: maxPriceData,
        });
        if (currentPageItem) {
            getFilterSizeData([currentPageItem]);
        }
    }, [currentPageItem]);
    useEffect(() => {
        if (router?.query?.item > 0) {
            filteredData(
                [changeCategory],
                changeSize,
                priceState,
                router.query.id,
                1
            );
        } else {
            discountedProductReq(router.query.id);
        }
    }, [router.query]);

    const handleChangePrice = async (evt) => {
        const value = evt.target.value;
        setPriceState({
            ...priceState,
            [evt.target.name]: value,
        });
    };
    useEffect(() => {
        if (priceState.minPrice || priceState.maxPrice) {
            filteredData([changeCategory], changeSize, priceState, page, 1);
        }
    }, [priceState.minPrice, priceState.maxPrice]);
    const handleClick = async (data) => {
        const index = data.selected;

        setPage(index + 1);
        if (currentPageQuery > 0 && !currentPageItem && !currentChangeSize) {
            router.push(`/discount/${index + 1}`);
        }
        if (currentPageItem > 0 && currentPageItem && !currentChangeSize) {
            router.push(`/discount/${index + 1}?item=${changeCategory}`);
        }
        if (currentChangeSize) {
            router.push(
                `/discount/${index + 1}?item=${changeCategory}&changeSize=${changeSize}`
            );
        }
        // if (router.query.item > 0) {
        //   router.push(`/discount/${index + 1}?item=${changeCategory}`);
        // } else {
        //   router.push(`${index + 1}`);
        // }

        // if (changeCategory > 0) {
        //   filteredData([changeCategory], changeSize, priceState, index + 1, 1);
        // } else {
        //   discountedProductReq(index + 1);
        // }
    };

    const getCategoryReq = async () => {
        const getCategoryReqData = await categoryGet_req();

        setAllCategory(getCategoryReqData);
    };
    useEffect(() => {
        getCategoryReq();
    }, [locale]);


    const meta = useMemo(() => {
        return {
            title: 'Ծանոթացեք Մեր Զեղչված Տեսականուն Այստեղ | Handle Brand',
            description: 'Գնեք զեղչված գներով հուշանվերներ, սեղանի խաղեր, բնական փայտից պատրաստված ձեռքի աշխատանքներ մեր խանութսրահից | Գնել հիմա'
        }
    }, [router.query])

    return (
        <Page meta={meta}>
            <div className="shop">
                <Banner
                    title={`${query?.discount === "discount"
                        ? intl.messages.discount
                        : intl.messages.shop
                        }`}
                    currentPage={`${query?.discount === "discount"
                        ? intl.messages.discount
                        : intl.messages.shop
                        }`}
                />
                <div className="wrapper">
                    <div className="filter-section flex flex-ai-center flex-jc-between">
                        <div className="filter-left flex flex-ai-center">
                            {/*<div className="filter-title">{intl.messages.filter}:</div>*/}
                            <SelectCustom
                                label={intl.messages.category}
                                handleChange={onchangeRadio}
                                name="changeCategory"
                                value={currentPageItem ? currentPageItem : changeCategory}
                                defaultFalue={"Select One"}
                                children={
                                    <>
                                        {!currentPageItem && (
                                            <option value="" disabled>
                                                {intl.messages.selectOne}
                                            </option>
                                        )}

                                        {allCategory?.data?.map((item, index) => (
                                            <option
                                                value={item.categoryId}
                                                selected={
                                                    changeCategory
                                                        ? changeCategory === item.categoryId
                                                        : queryData === item.id
                                                }
                                            >
                                                {item.name}
                                            </option>
                                        ))}
                                    </>
                                }
                            />
                            <div className="field-item price-range">
                                <span>{intl.messages.priceRange}</span>
                                <div>
                                    <input
                                        type="number"
                                        placeholder={intl.messages.from}
                                        onChange={handleChangePrice}
                                        value={priceState.minPrice}
                                        name="minPrice"
                                        min="0"
                                    />
                                    <input
                                        type="number"
                                        placeholder={intl.messages.to}
                                        onChange={handleChangePrice}
                                        value={priceState.maxPrice}
                                        name="maxPrice"
                                        min="0"
                                    />
                                </div>
                            </div>

                            {sizeData?.length > 0 && (
                                <div className="filter-category">
                                    <SelectCustom
                                        label={intl.messages.size}
                                        handleChange={onchangeRadioSize}
                                        name={intl.messages.size}
                                        value={changeSize}
                                        children={
                                            <>
                                                <option value="" disabled>
                                                    {intl.messages.selectOne}
                                                </option>
                                                {sizeData?.map((item, index) => (
                                                    <option value={item.id} selected={item.id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </>
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="flex flex-wrap">
                        {productList.length > 0 ? (
                            productList?.map((item) => (
                                <ProductItem
                                    image={item.image}
                                    name={item.title}
                                    size={item.size}
                                    price={item.price}
                                    code={item.code}
                                    categoryName={item.categoryName}
                                    tag={item.discount}
                                    oldPriceData={true}
                                    id={item.id}
                                    currency={item.currency}
                                />
                            ))
                        ) : (
                            <div className="product-not-found">
                                <img src={NotFoundIcon.src} alt="" />
                                <h4>{intl.messages.productNotFound}</h4>
                            </div>
                        )}
                    </div>
                    {productsPage?.pagesCount > 1 ? (
                        <ReactPaginate
                            previousLabel={<img src={LeftArrow.src} alt="" />}
                            nextLabel={<img src={RightArrow.src} alt="" />}
                            breakLabel={`...`}
                            pageCount={productsPage?.pagesCount}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={3}
                            onPageChange={(data) => handleClick(data)}
                            containerClassName={"pagination justify-content-center"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            activeClassName={"active"}
                            forcePage={currentPageQuery - 1}
                        />
                    ) : null}
                </div>
            </div>
        </Page>
    );
};
Discount.getInitialProps = ({ query }) => {
    return query;
};

export default Discount;
